export default __webpack_public_path__ + "static/media/led1_down.d1f9abd8.svg";